import { FuelCardRequester } from '@cobliteam/api-lib';
import type { FuelCardVehicle } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import * as ActionCreators from '@cobliteam/store/src/FuelCard/actionCreators';
import type * as Action from '@cobliteam/store/src/FuelCard/actions';
import { FuelCardActionTypes } from '@cobliteam/store/src/FuelCard/fuelCardActionTypes';
import Alert from '@cobliteam/ui/components/Alert';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const env = Environment.getInstance().getEnvironment();
const fuelCardRequester = new FuelCardRequester({ host: env.herbieApiHost });

const downloadReportFile = (blob: Blob, name: string, startInMilli: number, endInMilli: number): void => {
  const startTimeStr = moment(startInMilli).format('YYMMDD');
  const endTimeStr = moment(endInMilli).format('YYMMDD');
  const periodStr = startTimeStr === endTimeStr ? startTimeStr : `${startTimeStr}_${endTimeStr}`;

  const filename = `Cobli_${periodStr}_${name}.xlsx`;
  saveAs(blob, filename);
};

export function* requestDownloadTransactionsReportSaga(action: Action.DownloadTransactionsReportRequest) {
  const { period, vehicleGroupPaths } = action.payload;

  try {
    const reportBlob: Blob = yield call(fuelCardRequester.getTransactionsReport, period, vehicleGroupPaths);
    downloadReportFile(reportBlob, 'transacoes', period.start, period.end);
  } catch (err) {
    const msg = 'Ops! O sistema apresentou um erro e não foi possível exportar o relatório, tente novamente.';
    Alert.error(msg);
  } finally {
    yield put(ActionCreators.downloadTransactionsReportEnd());
  }
}

export function* requestLoadFuelVehiclesSaga() {
  try {
    const fuelVehicles: FuelCardVehicle[] = yield call(fuelCardRequester.getFuelVehicles);
    yield put(ActionCreators.loadFuelVehiclesSucceeded(fuelVehicles));
  } catch (err) {
    yield put(ActionCreators.loadFuelVehiclesFailed());
  }
}

export function* requestUpdateFuelVehiclesSaga(action: Action.UpdateFuelVehiclesRequest) {
  try {
    yield call(fuelCardRequester.updateFuelVehicles, action.payload);
    Alert.success('Alterações salvas com sucesso!');
  } catch (err) {
    const msg = 'Ops! O sistema apresentou um erro e não foi possível salvar as alterações agora, tente novamente.';
    Alert.error(msg);
  } finally {
    yield put(ActionCreators.updateFuelVehiclesEnd());
    yield put(ActionCreators.loadFuelVehiclesRequest());
  }
}

export function* FuelCardSagasListener() {
  yield all([
    takeLatest(FuelCardActionTypes.DOWNLOAD_TRANSACTIONS_REPORT_REQUEST, requestDownloadTransactionsReportSaga),
    takeLatest(FuelCardActionTypes.LOAD_FUEL_VEHICLES_REQUEST, requestLoadFuelVehiclesSaga),
    takeLatest(FuelCardActionTypes.UPDATE_FUEL_VEHICLES_REQUEST, requestUpdateFuelVehiclesSaga),
  ]);
}
